import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  subscriptionPlans: [],
  userSubscriptions: [],
  subscriptionSettings: {},
  loading: false,
  error: null,
  selectedPlan: null,
  userSubscriptionStatus: null
};

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setSubscriptionPlans: (state, action) => {
      state.subscriptionPlans = action.payload;
    },
    setUserSubscriptions: (state, action) => {
      state.userSubscriptions = action.payload;
    },
    setSubscriptionSettings: (state, action) => {
      state.subscriptionSettings = action.payload;
    },
    setSelectedPlan: (state, action) => {
      state.selectedPlan = action.payload;
    },
    setUserSubscriptionStatus: (state, action) => {
      state.userSubscriptionStatus = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    addSubscriptionPlan: (state, action) => {
      state.subscriptionPlans.push(action.payload);
    },
    updateSubscriptionPlan: (state, action) => {
      const index = state.subscriptionPlans.findIndex(plan => plan.id === action.payload.id);
      if (index !== -1) {
        state.subscriptionPlans[index] = action.payload;
      }
    },
    removeSubscriptionPlan: (state, action) => {
      state.subscriptionPlans = state.subscriptionPlans.filter(plan => plan.id !== action.payload);
    },
    updateUserSubscription: (state, action) => {
      const index = state.userSubscriptions.findIndex(sub => sub.id === action.payload.id);
      if (index !== -1) {
        state.userSubscriptions[index] = action.payload;
      }
    },
    clearError: (state) => {
      state.error = null;
    }
  }
});

export const {
  setSubscriptionPlans,
  setUserSubscriptions,
  setSubscriptionSettings,
  setSelectedPlan,
  setUserSubscriptionStatus,
  setLoading,
  setError,
  addSubscriptionPlan,
  updateSubscriptionPlan,
  removeSubscriptionPlan,
  updateUserSubscription,
  clearError
} = subscriptionSlice.actions;

export default subscriptionSlice.reducer;
